module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/battle-payments-elite-50.f9cdb7ed.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/battle-payments-elite-50.png
// module id = 3710
// module chunks = 11